import { qtdTotalDepentes } from './funcoesAuxiliaresZTA';

export class CorrenteCadastroZTA {
    constructor(dependentes, parentesco, categorias, valoresForm) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.maximoDependentes = 14;
        this.plano = 'ZELO TROCA ABERTA';
    }

    possui14dependentes() {
        const qtdTotalDependentes = qtdTotalDepentes(this.dependentes);

        if (qtdTotalDependentes === this.maximoDependentes) {
            this.arrayMsgsErro.push(`O plano ${this.plano} permite apenas ${this.maximoDependentes} dependentes.`);
        }

        return this;
    }
}
